
        var result = require("!!../../../../node_modules/css-loader/index.js!./bookmark-templates.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/bookmark-templates/bookmark-templates.component.css
// module id = 768
// module chunks = 0